import reduxWebsocket from '@giantmachines/redux-websocket';
import { configureStore } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import {
    PREFIX,
    PREFIX_AFTERSALES_PROJECTS,
    PREFIX_OCR,
    PREFIX_ZAP,
} from 'common/sockets/constants';

import createRootReducer from './modules/main/reducer';

export const history = createBrowserHistory();

export default function configureStoreApp(preloadedState) {
    const store = configureStore({
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({ serializableCheck: false })
                .concat(routerMiddleware(history))
                .concat(
                    reduxWebsocket({
                        prefix: PREFIX,
                        reconnectOnClose: true,
                    }),
                )
                .concat(
                    reduxWebsocket({
                        prefix: PREFIX_OCR,
                        reconnectOnClose: true,
                    }),
                )
                .concat(
                    reduxWebsocket({
                        prefix: PREFIX_AFTERSALES_PROJECTS,
                        reconnectOnClose: true,
                    }),
                )
                .concat(
                    reduxWebsocket({
                        prefix: PREFIX_ZAP,
                        reconnectOnClose: true,
                    }),
                ),
        preloadedState,
        reducer: createRootReducer(history),
    });

    return store;
}
